import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getDaysEnrichingActivities'
})
export class GetDaysEnrichingActivitiesPipe implements PipeTransform {

  transform(value: number): string {
    const daysOfTheWeek = [
      'Ningún dia a la semana',
      '1 día a la semana',
      '2 días a la semana',
      '3 días a la semana',
      '4 días a la semana',
      '5 días a la semana',
      '6 días a la semana',
      'Toda la semana',
    ];

    return daysOfTheWeek[value] ?? daysOfTheWeek[0];
  }

}
